module.exports = __webpack_public_path__ + "static/media/mutum-partitura.e0598ce1.png";